/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCapStraight = createReactComponent("outline", "cap-straight", "IconCapStraight", [["path", { "d": "M8 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0", "key": "svg-0" }], ["path", { "d": "M8 12h12", "key": "svg-1" }], ["path", { "d": "M20 6h-12a2 2 0 0 0 -2 2v2", "key": "svg-2" }], ["path", { "d": "M6 14v2a2 2 0 0 0 2 2h12", "key": "svg-3" }]]);

export { IconCapStraight as default };
//# sourceMappingURL=IconCapStraight.mjs.map
